<template>
    <div class="school-detail-wraper">
        <div class="card-top">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.meta.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="detail-top">
            <div class="top-logo">
                <img v-if="detail.gbdm"
                :src="imgBaseUrl+detail.gbdm+'.jpg'" :alt="detail.yxmc" width="100%">
            </div>
            <div class="top-mid">
                <div class="mid-school-name">
                    <h3 style="font-weight: 700 !important;">
                        {{ detail.yxmc }}
                    <template v-if="detail.sf985===1">
                        <img src="../assets/images/ico2.png" title="985">
                    </template>
                    <template v-if="detail.sf211===1">
                        <img src="../assets/images/ico1.png" title="211">
                    </template>
                    <template v-if="detail.sfsyl===1">
                        <img src="../assets/images/ico8.png" title="双一流">
                    </template>
                    <template v-if="detail.sf101===1">
                        <img src="../assets/images/ico9.png" title="101">
                    </template>
                    <template v-if="detail.yfyjsy===1">
                        <img src="../assets/images/ico3.png" title="研究生院">
                    </template>
                    </h3>
                    <el-button  type="primary" size="mini" @click="closeWin" plain round>关闭</el-button>
                </div>
                <div class="mid-school-nature">
                    <div class="nature-item">
                        <span>{{detail.yymc}}</span>
                    </div>
                    <!-- <div class="nature-item">
                        <span class="school-link">网址：{{detail.wz}}</span>
                    </div> -->
                </div>
            </div>
            <div></div>
        </div>
        <div class="detail-main">
            <el-tabs v-model="activeName" tab-position="left" type="card">
            <el-tab-pane label="专业组详情" name="1">
                <div class="schoolIntro_con2">
                    <div class="catTitle2">
                        <h2>专业组历年数据对比</h2>
                    </div>
                    <div class="txt"  id="lqTab" v-if="zyzTotals.list&&zyzTotals.list.length>0">
                        <table class="info-data">
                            <tr>
                                <th rowspan="2">专业组</th>
                                <th rowspan="2">年度</th>
                                <th colspan="6">录取分</th>
                                <th colspan="3">等效分</th>
                                <th>计划人数</th>
                                <th rowspan="2" v-if="type==='1'">操作</th>
                            </tr>
                            <tr>
                                <th>最低分</th>
                                <th>平均分</th>
                                <th>最高分</th>
                                <th>投档线</th>
                                <th>线差</th>
                                <el-tooltip placement="top">
                                <div slot="content">我的省排名{{userInfo.spm}}</div>
                                <th>入档位次</th>
                                </el-tooltip>
                                <th>最低分</th>
                                <th>平均分</th>
                                <th>最高分</th>
                                <th>今年</th>
                            </tr>
                                <!-- <tr v-for="(item,index) in zyzTotals.sub" :key="index">
                                <td :rowspan="zyzRowspan" v-if="index===0&&type==='1'">
                                    <a href="javascript:void(0)" style="color:#2186de;">[{{zyzTotals.zyz}}]</a>
                                    <span style="display:block;width:41px;height:5px"></span>
                                    <div class="collectBtn" v-if="zyzTotals.sfsc===0" @click="addCollect(zyzTotals.zyz,zyzTotals.sfsc)">加入收藏</div>
                                    <div class="collectBtn" v-if="zyzTotals.sfsc===1" @click="addCollect(zyzTotals.zyz,zyzTotals.sfsc)">取消收藏</div>
                                </td>
                                <td :rowspan="zyzRowspan" v-if="index===0&&type==='2'">
                                    <a href="javascript:void(0)" style="color:black;">{{zyzTotals.zyz}}</a>
                                </td>
                                <td>{{item.nd?item.nd:item.nd===0?'平均分':'-'}}</td>
                                <td>{{!item.zdf?'-':item.zdf}}</td>
                                <td>{{!item.pjf?'-':item.pjf}}</td>
                                <td>{{!item.zgf?'-':item.zgf}}</td>
                                <td>{{!item.tdx?'-':item.tdx}}</td>
                                <td>{{!item.xc?'-':item.xc}}</td>
                                <td>{{!item.rdwc?'-':item.rdwc}}</td>
                                <td v-if="item.nd===0" class="yuceTdx">{{!item.zdtwf?'-':item.zdtwf}}</td>
                                <td v-if="item.nd!==0">{{!item.zdtwf?'-':item.zdtwf}}</td>
                                <td>{{!item.pjtwf?'-':item.pjtwf}}</td>
                                <td>{{!item.zgtwf?'-':item.zgtwf}}</td>
                                <td :rowspan="zyzRowspan" v-if="index===0">{{zyzTotals.jnjhs}}</td>
                                </tr> -->
                                <tbody v-for="(item0,index0) in zyzTotals.list" :key="index0">
                                <tr v-for="(item,index) in item0.sub" :key="index">
                                    <td :rowspan="zyzRowspan" v-if="index===0&&type==='1'">
                                        <a href="javascript:void(0)" style="color:#2186de;"
                                        @click="toZyzDetail(detail.gbdm,detail.yxxh,detail.yxmc,item0.zyz,detail.pc,detail.lx||null)">[{{item0.zyz}}]</a>
                                        <span style="display:block;width:41px;height:5px"></span>
                                        <div class="collectBtn" :loading="collectLoading" v-if="item0.isSc===0" @click="addCollect(item0.zyz,zyzTotals.sfsc,'3')">加入收藏</div>
                                        <div class="collectBtn" :loading="collectLoading" v-if="item0.isSc===1" @click="addCollect(item0.zyz,zyzTotals.sfsc,'3')">取消收藏</div>
                                    </td>
                                    <td :rowspan="zyzRowspan" v-if="index===0&&type==='2'">
                                        <a href="javascript:void(0)" style="color:black;">{{item0.zyz}}</a>
                                    </td>
                                    <td>{{item.nd?item.nd:item.nd===0?'平均分':'-'}}</td>
                                    <td>{{!item.zdf?'-':item.zdf}}</td>
                                    <td>{{!item.pjf?'-':item.pjf}}</td>
                                    <td>{{!item.zgf?'-':item.zgf}}</td>
                                    <td>{{!item.tdx?'-':item.tdx}}</td>
                                    <td>{{!item.xc?'-':item.xc}}</td>
                                    <td>{{!item.rdwc?'-':item.rdwc}}</td>
                                    <td v-if="item.nd===0" class="yuceTdx">{{!item.zdtwf?'-':item.zdtwf}}</td>
                                    <td v-if="item.nd!==0">{{!item.zdtwf?'-':item.zdtwf}}</td>
                                    <td>{{!item.pjtwf?'-':item.pjtwf}}</td>
                                    <td>{{!item.zgtwf?'-':item.zgtwf}}</td>
                                    <td :rowspan="zyzRowspan" v-if="index===0">{{item.jnjhs}}</td>
                                    <td :rowspan="zyzRowspan" v-if="index===0&&type==='1'">
                                        <el-button type="primary" size="small" @click="toZyzDetail2((item.gbdm||item0.gbdm||detail.gbdm),(item.zyz||item0.zyz),
                                        (item.pc||item0.pc),(item.yxmc||item0.yxmc||detail.yxmc),(item.yxxh||item0.yxxh),null,{...item0,...showYxObj})" :disabled="item.isCanDisabled"
                                        :loading="item.isCanDisabled">
                                            专业组详情
                                            <span v-if="item.isShowZyzDetail===false" class="el-icon-arrow-up"></span>
                                            <span v-else class="el-icon-arrow-down"></span>
                                        </el-button>
                                    </td>
                                </tr>
                                </tbody>
                        </table>
                    </div>
                    <div v-for="(item0,index0) in zyzTotals.list" :key="index0">
                        <div v-for="(item,index) in item0.sub" :key="index">
                            <div v-show="item.isShowZyzDetail" class="schoolIntro_con2" style="margin-left: 0;">
                                <div class="catTitle2">
                                    <h2>专业组历年数据对比</h2>
                                </div>
                                <div class="txt"  id="lqTab" v-if="zyzTotals2.list&&zyzTotals2.list.length>0">
                                    <table class="info-data" style="box-sizing: border-box;">
                                        <tr>
                                            <th rowspan="2">专业组</th>
                                            <th rowspan="2">年度</th>
                                            <th colspan="6">录取分</th>
                                            <th colspan="3">等效分</th>
                                            <th>计划人数</th>
                                        </tr>
                                        <tr>
                                            <th>最低分</th>
                                            <th>平均分</th>
                                            <th>最高分</th>
                                            <th>投档线</th>
                                            <th>线差</th>
                                            <el-tooltip placement="top">
                                            <div slot="content">我的省排名{{userInfo.spm}}</div>
                                            <th>入档位次</th>
                                            </el-tooltip>
                                            <th>最低分</th>
                                            <th>平均分</th>
                                            <th>最高分</th>
                                            <th>今年</th>
                                        </tr>
                                            <tbody v-for="(item0,index0) in zyzTotals2.list" :key="index0">
                                            <tr v-for="(item2,index) in item0.sub" :key="index">
                                            <td :rowspan="zyzRowspan" v-if="index===0">
                                                <a href="javascript:void(0)" style="color:black;">{{item0.zyz}}</a>
                                            </td>
                                            <td>{{item2.nd?item2.nd:item2.nd===0?'平均分':'-'}}</td>
                                            <td>{{!item2.zdf?'-':item2.zdf}}</td>
                                            <td>{{!item2.pjf?'-':item2.pjf}}</td>
                                            <td>{{!item2.zgf?'-':item2.zgf}}</td>
                                            <td>{{!item2.tdx?'-':item2.tdx}}</td>
                                            <td>{{!item2.xc?'-':item2.xc}}</td>
                                            <td>{{!item2.rdwc?'-':item2.rdwc}}</td>
                                            <td v-if="item2.nd===0" class="yuceTdx">{{!item2.zdtwf?'-':item2.zdtwf}}</td>
                                            <td v-if="item2.nd!==0">{{!item2.zdtwf?'-':item2.zdtwf}}</td>
                                            <td>{{!item2.pjtwf?'-':item2.pjtwf}}</td>
                                            <td>{{!item2.zgtwf?'-':item2.zgtwf}}</td>
                                            <td :rowspan="zyzRowspan" v-if="index===0">{{item2.jnjhs}}</td>
                                            </tr>
                                            </tbody>
                                    </table>
                                </div>
                                <div class="catTitle2">
                                    <h2>专业详情表</h2>
                                </div>
                                <div class="txt order" style="width:990px;">
                                <div class="yx_zy_group">
                                    <div class="group_title">
                                        <div class="zyz_title">专业组{{zyz2}}</div>
                                        <div class="collect" :loading="collectLoading" v-if="isSc2===0" @click="addCollect(zyz2,zyzTotals2.sfsc,'2')">加入收藏</div>
                                        <div class="collect" :loading="collectLoading" v-if="isSc2===1" @click="addCollect(zyz2,zyzTotals2.sfsc,'2')">取消收藏</div>
                                    </div>
                                    <div class="group_content" v-for="(item2,index) in zyTotals2"
                                    :key="index">
                                        <div class="zy_name" :title="item2.zybz">
                                            <span class="index">{{index+1}}</span>
                                            <span :class="[item2.isRed?'seMangSeRuo':'']"> {{item2.zymc}} </span>
                                            <!-- {{item2.zymc}} -->
                                            <span class="tip">{{item2.zybz}}</span>
                                        </div>
                                        <div class="zy_attrs">
                                            <div class="attr-item">
                                                <span v-if="item2.sxkm===2">首选科目：物理</span>
                                                <span v-if="item2.sxkm===1">首选科目：历史</span>
                                            </div>
                                            <div class="attr-item">
                                                <span>再选科目要求：{{item2.zxkmyq}}</span>
                                            </div>
                                            <div class="attr-item">
                                                <span>今年计划数：{{item2.jnjhs}}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="zyData">
                                    <el-table :data="zyData2.filter(data=>!searchZy||data.zymc.indexOf(searchZy)>=0)" max-height="770" :span-method="objectSpanMethod"
                                    :header-cell-style="{'background-color':'#f5f7fa','border': '1px solid #09F',
                                    'color': 'rgb(144, 147, 153)','text-align':'center','font-weight':'700','font-size':'14px'}" :cell-class-name="getCellClass"
                                    :cell-style="objectCellMethod" size="small">
                                    <el-table-column show-overflow-tooltip label="专业名称" prop="zymc" width="115" :resizable="false"></el-table-column>
                                    <el-table-column show-overflow-tooltip label="一流学科" prop="zdzy" width="75" :resizable="false">
                                        <template slot-scope="scope">
                                            <img style="width:25px;height:25px;" src="../assets/images/gou.png" v-if="scope.row.zdzy===1"/>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip label="年份" width="70" prop="nd" :resizable="false">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.nd!==0">{{scope.row.nd}}</span>
                                            <span v-if="scope.row.nd===0">平均</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip label="录取分" :resizable="false">
                                        <el-table-column label="最低" width="75" prop="zdf" :resizable="false"></el-table-column>
                                        <el-table-column label="平均" width="75" prop="pjf" :resizable="false"></el-table-column>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip label="专业线差" width="75" prop="xc" :resizable="false"></el-table-column>
                                    <el-table-column show-overflow-tooltip label="专业入档位次" width="70" prop="rdwc" :resizable="false"></el-table-column>
                                    <el-table-column show-overflow-tooltip label="等效分" :resizable="false">
                                        <el-table-column label="最低" width="65" prop="zdtwf" :resizable="false"></el-table-column>
                                        <el-table-column label="平均" width="65" prop="pjtwf" :resizable="false"></el-table-column>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip label="往年批次" width="70" prop="pc" :resizable="false">
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.pc===6">本科批</span>
                                            <span v-if="scope.row.pc===7">专科批</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip label="计划人数" :resizable="false">
                                        <el-table-column label="历年" width="65" prop="jhs" :resizable="false"></el-table-column>
                                        <el-table-column label="今年" width="65" prop="jnjhrs" :resizable="false"></el-table-column>
                                    </el-table-column>
                                    <el-table-column show-overflow-tooltip label="操作" :resizable="false"
                                    :key="updateZyList" align="center">      
                                    <template slot="header">
                                        <el-input
                                        v-model="searchZy"
                                        size="mini"
                                        placeholder="输入关键字搜索"/>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button type="primary" size="small" @click="addSchoolList(scope.row,showYxObj,'2')"
                                        v-if="scope.row.zyBtnTxt.indexOf('专业')===-1" :disabled="scope.row.isDisabled">{{ scope.row.zyBtnTxt }}</el-button>
                                        <el-button size="small" @click="addSchoolList(scope.row,showYxObj,'2')"
                                        v-if="scope.row.zyBtnTxt.indexOf('专业')>=0" :disabled="scope.row.isDisabled"
                                        style="background-color: #0479f5;color: white;border: 1px solid #0479f5;"
                                        >{{ scope.row.zyBtnTxt }}</el-button>
                                    </template>
                                    </el-table-column>
                                </el-table>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="catTitle2" v-if="type==='2'">
                        <h2>专业详情表</h2>
                    </div>
                    <div class="txt order" style="width:990px;" v-if="type==='2'">
                    <div class="yx_zy_group">
                        <div class="group_title">
                            <div class="zyz_title">专业组{{zyz}}</div>
                            <div class="collect" :disabled="collectLoading" v-if="isSc===0" @click="addCollect(zyz,zyzTotals.sfsc,'1')">加入收藏</div>
                            <div class="collect" :disabled="collectLoading" v-if="isSc===1" @click="addCollect(zyz,zyzTotals.sfsc,'1')">取消收藏</div>
                        </div>
                        <div class="group_content" v-for="(item,index) in zyTotals"
                        :key="index">
                        <!-- 色弱色盲专业名称和提醒标红  :class="[item.isRed?'seMangSeRuo':'']"
                         -->
                            <div class="zy_name" :title="item.zybz">
                                <span class="index">{{index+1}}</span>
                                <span :class="[item.isRed?'seMangSeRuo':'']"> {{item.zymc}} </span>
                                <!-- {{item.zymc}} -->
                                <span class="tip">{{item.zybz}}</span>
                            </div>
                            <div class="zy_attrs">
                                <div class="attr-item">
                                    <span v-if="item.sxkm===2">首选科目：物理</span>
                                    <span v-if="item.sxkm===1">首选科目：历史</span>
                                </div>
                                <div class="attr-item">
                                    <span>再选科目要求：{{item.zxkmyq}}</span>
                                </div>
                                <div class="attr-item">
                                    <span>今年计划数：{{item.jnjhs}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="sti-tbl-container">
                        <div class="sti-tbl-header" style="padding-right:17px;">
                        <table></table>
                        </div>
                        <div class="sti-tbl-body">
                            <table></table>
                        </div>
                    </div> -->
                    <div id="zyData" v-if="zyData.length>0">
                        <el-table :data="zyData.filter(data=>!searchZy||data.zymc.indexOf(searchZy)>=0)" max-height="770" :span-method="objectSpanMethod"
                        :header-cell-style="{'background-color':'#f5f7fa','border': '1px solid #09F',
                        'color': 'rgb(144, 147, 153)','text-align':'center','font-weight':'700','font-size':'14px'}" :cell-class-name="getCellClass"
                        :cell-style="objectCellMethod" size="small">
                        <el-table-column show-overflow-tooltip label="专业名称" prop="zymc" width="105" :resizable="false"></el-table-column>
                        <el-table-column show-overflow-tooltip label="一流学科" prop="zdzy" width="75" :resizable="false">
                            <template slot-scope="scope">
                                <img style="width:25px;height:25px;" src="../assets/images/gou.png" v-if="scope.row.zdzy===1"/>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="年份" width="60" prop="nd" :resizable="false">
                            <template slot-scope="scope">
                                <span v-if="scope.row.nd!==0">{{scope.row.nd}}</span>
                                <span v-if="scope.row.nd===0">平均</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="录取分" :resizable="false">
                            <el-table-column label="最低" width="75" prop="zdf" :resizable="false"></el-table-column>
                            <el-table-column label="平均" width="75" prop="pjf" :resizable="false"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="专业线差" width="75" prop="xc" :resizable="false"></el-table-column>
                        <el-table-column show-overflow-tooltip label="专业入档位次" width="70" prop="rdwc" :resizable="false"></el-table-column>
                        <el-table-column show-overflow-tooltip label="等效分" :resizable="false">
                            <el-table-column label="最低" width="65" prop="zdtwf" :resizable="false"></el-table-column>
                            <el-table-column label="平均" width="65" prop="pjtwf" :resizable="false"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="往年批次" width="70" prop="pc" :resizable="false">
                            <template slot-scope="scope">
                                <span v-if="scope.row.pc===6">本科批</span>
                                <span v-if="scope.row.pc===7">专科批</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="计划人数" :resizable="false">
                            <el-table-column label="历年" width="65" prop="jhs" :resizable="false"></el-table-column>
                            <el-table-column label="今年" width="65" prop="jnjhrs" :resizable="false"></el-table-column>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip label="操作" :resizable="false"
                        :key="updateZyList" align="center">      
                          <template slot="header">
                            <el-input
                              v-model="searchZy"
                              size="mini"
                              placeholder="输入关键字搜索"/>
                          </template>
                          <template slot-scope="scope">
                            <el-button type="primary" size="small" @click="addSchoolList(scope.row,showYxObj,'1')"
                            v-if="scope.row.zyBtnTxt.indexOf('专业')===-1" :disabled="scope.row.isDisabled">{{ scope.row.zyBtnTxt }}</el-button>
                            <el-button size="small" @click="addSchoolList(scope.row,showYxObj,'1')"
                            v-if="scope.row.zyBtnTxt.indexOf('专业')>=0" :disabled="scope.row.isDisabled"
                            style="background-color: #0479f5;color: white;border: 1px solid #0479f5;">{{ scope.row.zyBtnTxt }}</el-button>
                          </template>
                        </el-table-column>
                    </el-table>
                    </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="院校简介" name="2">
                <div style="margin-left:15px;">
                    <div class="schoolIntro_con">
                    <div class="intro"  style="text-indent: 28px;" id="jjDiv">{{ detail.jj }}</div>
                    <div class="read-more" style="text-align: right;">
                    <a href="javascript:void(0)" @click="watchAndStop">{{detailTxt}}</a>
                    <div class="baseInfo clearfix">
                        <ul class="baseInfo_left">
                            <li class="biItem">
                                <span class="t">创建时间</span>
                                <div class="c" id="cjsj">{{detail.jxsj}}</div>
                            </li>
                            <li class="biItem">
                                <span class="t">隶属于</span>
                                <div class="c" id="ls">{{detail.ls}}</div>
                            </li>
                            <li class="biItem">
                                <span class="t">学生人数</span>
                                <div class="c" id="xsrs">{{detail.xsrs}}</div>
                            </li>
                            <li class="biItem">
                                <span class="t">院士人数</span>
                                <div class="c" id="ysrs">{{detail.ysrs}}</div>
                            </li>
                            <li class="biItem">
                                <span class="t">男生比例</span>
                                <div class="c" id="nsbl">{{detail.nsbl}}</div>
                            </li>
                        </ul>
                        <ul class="baseInfo_right">
                            <li class="biItem">
                                <span class="t">一流学科</span>
                                <div class="c" id="zdxk">
                                    {{detail.ylxkSize}}
                                </div>
                            </li>
                            <li class="biItem">
                                <span class="t">学校类型</span>
                                <div class="c" id="xxlx">
                                    {{detail.xxlbmc}}
                                </div>
                            </li>
                            <li class="biItem">
                                <span class="t">博士点个数</span>
                                <div class="c" id="bsdgs">{{detail.bsdgs}}</div>
                            </li>
                            <li class="biItem">
                                <span class="t">硕士点个数</span>
                                <div class="c" id="ssdgs">{{detail.ssdgs}}</div>
                            </li>
                            <li class="biItem">
                                <span class="t">女生比例</span>
                                <div class="c" id="nvsbl">{{detail.nvsbl}}</div>
                            </li>
                        </ul>
                    </div>
                    <!-- <div class="catTitle">
                        <h2>学费信息</h2>
                    </div>
                    <div class="txt" style="text-indent:28px;" id="xfxx" v-html="detail.xfxx">
                    </div> -->
                    <div class="catTitle">
                        <h2>就业情况</h2>
                    </div>
                    <div class="txt" style="text-indent:28px;" id="jyqk" v-html="detail.jyqk">
                    </div>
                    <div class="txt">
                        以上数据由金榜志愿通<a href></a>汇总整理。
                    </div>
                    </div>
                </div>
                <div class="schoolIntro_side">
                    <div class="schoolIntro_sideBd">
                        <div class="pics">
                            <div class="schoolPic_slide">
                                <ul>
                                    <li>
                                        <img id="yxtb_xgt" :src="xiaoguoBaseUrl+detail.gbdm+'8.jpg'" :alt="detail.yxmc"/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="infos">
                            <ul>
                                <li>
                                    <label>所在城市：</label>
                                    <font id="ss">{{detail.szdqmc}}</font>
                                </li>
                                <li>
                                    <label>学校地址：</label>
                                    <font id="xxdz">{{detail.dz}}</font>
                                </li>
                                <li>
                                    <label>招生电话：</label>
                                    <font id="zsdh">{{detail.dh}}</font>
                                </li>
                                <!-- <li>
                                    <label>电子邮箱：</label>
                                    <font id="dzyx">{{detail.dzyx}}</font>
                                </li> -->
                            </ul>
                            <!-- <div class="website">
                                <a :href="detail.wz" target="_blank" class="a1">进入官网</a>
                                <a :href="detail.zswz" target="_blank" class="a2">进入招生网站</a>
                            </div> -->
                            <div class="website">
                                <el-button type="primary" size="small"
                                style="margin-right: 13px;" @click="goSchoolLink(detail.wz)">进入官网</el-button>
                                <el-button type="primary" size="small"
                                @click="goSchoolLink(detail.zswz)">进入招生网站</el-button>
                            </div>
                        </div>
                        <!-- <div class="hotschool">
                            <div class="hd"></div>
                            <div class="hd"></div>
                        </div> -->
                    </div>
                </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="学科详情" name="3">
                <div class="schoolIntro_con22" v-if="detail.zdzys1.length>0">
                    <div class="majorCon2">
                        <h3>{{ detail.zdzyTitle1 }}（{{detail.zdzys1.length}}个）</h3>
                    </div>
                    <div class="majorCon1" id="gjppzyDiv">
                        <ul class="list clearfix" id="gjppzy">
                            <li v-for="(item,index) in detail.zdzys1" :key="index">
                                ● <a href="javascript:void(0)" :zy_zyid="item.zydm" @click="toZyDetail(item.zydm)">{{item.zymc}}</a>
                                <!-- <span>{{ item.ylxx }}</span> <a href="javascript:void(0)" :zy_zyid="item.zydm" @click="toZyDetail(item.zydm)">{{item.zymc}}</a> -->
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="schoolIntro_con22" v-if="detail.zdzys2.length>0">
                    <div class="majorCon2">
                        <h3>{{ detail.zdzyTitle2 }}（{{detail.zdzys2.length}}个）</h3>
                    </div>
                    <div class="majorCon1" id="gjppzyDiv">
                        <ul class="list clearfix" id="gjppzy">
                            <li v-for="(item,index) in detail.zdzys2" :key="index">
                                ● <a href="javascript:void(0)" :zy_zyid="item.zydm" @click="toZyDetail(item.zydm)">{{item.zymc}}</a>
                                <!-- <span>{{ item.ylxx }}</span> <a href="javascript:void(0)" :zy_zyid="item.zydm" @click="toZyDetail(item.zydm)">{{item.zymc}}</a> -->
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="schoolIntro_con22" v-if="detail.zdzys3.length>0">
                    <div class="majorCon2" style="border-left: none;">
                        <h3> </h3>
                    </div>
                    <div class="majorCon1" id="gjppzyDiv">
                        <ul class="list clearfix" id="gjppzy">
                            <li v-for="(item,index) in detail.zdzys3" :key="index">
                                ● <a href="javascript:void(0)" :zy_zyid="item.zydm" @click="toZyDetail(item.zydm)">{{item.zymc}}</a>
                                <!-- <span>{{ item.ylxx }}</span> <a href="javascript:void(0)" :zy_zyid="item.zydm" @click="toZyDetail(item.zydm)">{{item.zymc}}</a> -->
                            </li>
                        </ul>
                    </div>
                </div>
                <div style="text-align: center;display: flex;justify-content: center;
                align-items: center;height: 100px;font-size: 18px;" v-if="detail.zdzys1.length==0
                &&detail.zdzys2.length==0&&detail.zdzys3.length==0">
                    <!-- <span>暂无数据</span> -->
                    <span>该校学科正在努力建设ing...</span>
                </div>
            </el-tab-pane>
            <el-tab-pane label="招生章程" name="4">
                <div class="schoolIntro_con23">
                    <div class="majorCon2">
                        <h3>招生章程</h3>
                    </div>
                    <div class="txt" id="zsjz" v-html="detail.zszc"></div>
                </div>
            </el-tab-pane>
        </el-tabs>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex';
// import $ from 'jquery';
import {imgBaseUrl,xiaoguoBaseUrl} from '../common/imgBaseUrl';
export default {
props:["type"],
data(){
    return{
        activeName:"1",
        detail:{
            logo:"",
            dz:"",
            yxmc:"",
            wz:"",
            jxsj:"",
            ls:"",
            xsrs:"",
            bsdgs:"",
            ssdgs:"",
            ysrs:"",
            nsbl:"",
            nvsbl:"",
            jj:"",
            lsjj:"",
            xfxx:"",
            jyqk:"",
            szdqmc:"",
            dh:"",
            dzyx:"",
            ylxks:[],
            zswz:"",
            zszc:"",
            yymc:"",
            sf985:0,
            sf211:0,
            sf101:0,
            yfyjsy:0,
            sfsyl:0,
            gbdm:"",
            xxlbmc:"",
            xxlb:"",
            ylxkSize:"",
            yxxh:"",
            pc:"",
            lx:"",
            zdzyTitle1:'',
            zdzyTitle2:'',
            zdzyTitle3:'',
            zdzys1:[],
            zdzys2:[],
            zdzys3:[]
        },
        zyzTotals:{
            list:[]
        },
        zyData:[],
        xh:"",
        scZyzSize:0,
        isSc:0,
        zyz:"",
        collectLoading:false,
        zyzRowspan:"",
        maxwidth:300,
        zyTotals:[],
        detailTxt:"查看详情 >>",
        searchZy:'',
        schoolList:[],
        updateZyList:false,
        imgBaseUrl:imgBaseUrl,
        xiaoguoBaseUrl:xiaoguoBaseUrl,
        condition:"",
        zyzTotals2:{
            list:[]
        },
        detail2:{
            logo:"",
            dz:"",
            yxmc:"",
            wz:"",
            jxsj:"",
            ls:"",
            xsrs:"",
            bsdgs:"",
            ssdgs:"",
            ysrs:"",
            nsbl:"",
            nvsbl:"",
            jj:"",
            lsjj:"",
            xfxx:"",
            jyqk:"",
            szdqmc:"",
            dh:"",
            dzyx:"",
            ylxks:[],
            zswz:"",
            zszc:"",
            yymc:"",
            sf985:0,
            sf211:0,
            sf101:0,
            yfyjsy:0,
            sfsyl:0,
            gbdm:"",
            xxlbmc:"",
            xxlb:"",
            ylxkSize:"",
            yxxh:"",
            pc:"",
            lx:"",
            zdzyTitle1:'',
            zdzyTitle2:'',
            zdzyTitle3:'',
            zdzys1:[],
            zdzys2:[],
            zdzys3:[]
        },
        showYxObj:{},
        zyTotals2:[],
        zyzRowspan2:"",
        zyz2:"",
        isSc2:"",
        zyData2:[]
    };
},
methods:{
    // 获取院校详情数据
    async getSchoolDeatil(){
        const loading=this.$loading({fullscreen:true,target:document.getElementById("lqTab"),text:"正在加载中"});
        let { gbdm, zyz = null,pc,yxmc,yxxh,type=null } = this.$route.query;
        const res=await this.$http.postHttp("/yxcx/getYxDetail",{
            gbdm,
            zyz,
            pc,
            yxmc,
            yxxh
        });
        if(res.data.code===200){
            this.detail.logo=res.data.obj.yxml.logo;
            this.detail.dz=res.data.obj.yxml.dz;
            this.detail.wz=res.data.obj.yxml.xxwz;
            this.detail.yxmc=res.data.obj.yxmcStr;
            this.detail.jj=res.data.obj.yxml.jj;
            this.detail.jxsj=res.data.obj.yxml.jxsj;
            this.detail.ls=res.data.obj.yxml.ls;
            this.detail.xsrs=res.data.obj.yxml.xsrs;
            this.detail.bsdgs=res.data.obj.yxml.bsdgs;
            this.detail.ysrs=res.data.obj.yxml.ysrs;
            this.detail.ssdgs=res.data.obj.yxml.ssdgs;
            this.detail.nsbl=res.data.obj.yxml.nsbfb;
            this.detail.nvsbl=res.data.obj.yxml.nvsbfb;
            this.detail.xfxx=res.data.obj.yxml.xfxx;
            this.detail.jyqk=res.data.obj.yxml.jyqk;
            const zdzys=[...res.data.obj.zdzys];
            const zyArr1=[];
            const zyArr2=[];
            const zyArr3=[];
            for(let i=0;i<zdzys.length;i++){
                if(zdzys[i].ylxx==='A类'){
                    zyArr1.push(zdzys[i]);
                }else if(zdzys[i].ylxx==='B类'){
                    zyArr2.push(zdzys[i]);
                }else if(!zdzys[i].ylxx&&zdzys[i].zymc){
                    zyArr3.push(zdzys[i]);
                }
            }
            this.detail.zdzyTitle1='A类';
            this.detail.zdzyTitle2='B类';
            this.detail.zdzyTitle3='';
            this.detail.zdzys1=zyArr1;
            this.detail.zdzys2=zyArr2;
            this.detail.zdzys3=zyArr3;
            this.detail.ylxks=res.data.obj.zdzys;
            this.detail.szdqmc=res.data.obj.yxml.szdqmc;
            this.detail.dh=res.data.obj.yxml.dh;
            this.detail.dzyx=res.data.obj.yxml.dzyj;
            this.detail.zswz=res.data.obj.yxml.zswz;
            this.detail.zszc=res.data.obj.yxml.zszc;
            this.detail.yymc=res.data.obj.yxml.yxywmc;
            this.detail.sf985=res.data.obj.yxml.sf985;
            this.detail.sf211=res.data.obj.yxml.sf211;
            this.detail.sfsyl=res.data.obj.yxml.sfsyl;
            this.detail.yfyjsy=res.data.obj.yxml.yfyjsy;
            this.detail.sf101=res.data.obj.yxml.sf101;
            this.detail.gbdm=res.data.obj.yxml.gbdm;
            this.detail.xxlb=res.data.obj.yxml.xxlb;
            this.detail.xxlbmc=res.data.obj.yxml.xxlbmc;
            this.detail.ylxkSize=res.data.obj.zdzysSize;
            this.detail.yxxh=res.data.obj.yxxhStr;
            this.detail.pc=pc;
            this.detail.lx=type;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }else if(res.data.msg){
                this.$message({message:res.data.msg,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        if(zyz===""){
            zyz=null;
        }
        if(type===''){
            type=null;
        }
        this.condition=type;
        const res2=await this.$http.postHttp("/yxcx/getLqxq",{
            kl:this.userInfo.kl,
            pc,
            yxxh,
            zxkma:this.userInfo.zxkma,
            zxkmb:this.userInfo.zxkmb,
            zyz,
            condition:type
        });
        if(res2.data.code===200){
            // this.zyzTotals=res2.data.obj.zyzTotals[0];
            const len=res2.data.obj.zyzTotals.length;
            const zyzs=res2.data.obj.zyzTotals;
            for(let i=0;i<len;i++){
                const zyz=zyzs[i].zyz;
                if(res2.data.obj.zyz[zyz]){
                    const isSc=res2.data.obj.zyz[zyz].isSc;
                    if(isSc){
                        zyzs[i].isSc=1;
                    }else{
                        zyzs[i].isSc=0;
                    }
                }
            }
            const data2=[...res2.data.obj.zyzTotals];
            console.log(data2);
            for(let i=0;i<data2.length;i++){
                if(data2[i]){
                    const subs=data2[i].sub;
                    for(let j=0;j<subs.length;j++){
                        if(j%4===0){
                            subs[j].isCanDisabled=false;
                            subs[j].isShowZyzDetail=false;
                        }
                    }
                }
            }
            // for(let i=0;i<data2.length;i++){
            //     data2[i].isShowZyzDetail=false;
            //     data2[i].isCanDisabled=false;
            // }
            this.zyzTotals.list=data2;
            this.showYxObj={gbdm,zyz,pc,yxmc,yxxh,type};
            if(res2.data.obj.zyzTotals[0]&&res2.data.obj.zyzTotals[0].sub){
                this.zyzRowspan=res2.data.obj.zyzTotals[0].sub.length;
                this.showYxObj.sub=res2.data.obj.zyzTotals[0].sub;
            }else{
                this.$message({
                    type:'error',
                    message:"没有查到相关数据"
                });
            }
            // this.zyzTotals.zyz=res2.data.obj.zyz;
            // this.zyzRowspan=4;
            // this.zyzTotals.jnjhs=res2.data.obj.zyzTotals[0].sub[0].jnjhs;
            // this.zyzTotals.sfsc=res2.data.obj.sfsc;
        }else if(res2.data.code===500){
            if(res2.data.message){
                this.$message({message:res2.data.message,type:"error"});
            }else if(res2.data.msg){
                this.$message({message:res2.data.msg,type:"error"});
            }
        }else if(res2.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res2.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        loading.close();
    },
    // 获取院校专业组详情数据
    async getZyzDeatil(){
        const loading=this.$loading({fullscreen:true,target:document.getElementById("lqTab"),text:"正在加载中"});
        const loading2=this.$loading({fullscreen:true,target:document.getElementById("zyData"),text:"正在加载中"});
        const { gbdm, zyz = null,pc,yxmc,yxxh,type=null } = this.$route.query;
        const res=await this.$http.postHttp("/yxcx/getYxZyzDetail",{
            gbdm,
            zyz,
            pc,
            yxmc,
            yxxh
        });
        const selectZydhData=[];
        if(res.data.code===200){
            this.detail.logo=res.data.obj.yxml.logo;
            this.detail.dz=res.data.obj.yxml.dz;
            this.detail.wz=res.data.obj.yxml.xxwz;
            this.detail.yxmc=res.data.obj.yxmcStr;
            this.detail.jj=res.data.obj.yxml.jj;
            this.detail.jxsj=res.data.obj.yxml.jxsj;
            this.detail.ls=res.data.obj.yxml.ls;
            this.detail.xsrs=res.data.obj.yxml.xsrs;
            this.detail.bsdgs=res.data.obj.yxml.bsdgs;
            this.detail.ysrs=res.data.obj.yxml.ysrs;
            this.detail.ssdgs=res.data.obj.yxml.ssdgs;
            this.detail.nsbl=res.data.obj.yxml.nsbfb;
            this.detail.nvsbl=res.data.obj.yxml.nvsbfb;
            this.detail.xfxx=res.data.obj.yxml.xfxx;
            this.detail.jyqk=res.data.obj.yxml.jyqk;
            const zdzys=[...res.data.obj.zdzys];
            const zyArr1=[];
            const zyArr2=[];
            for(let i=0;i<zdzys.length;i++){
                if(zdzys[i].ylxx==='A类'){
                    zyArr1.push(zdzys[i]);
                }else if(zdzys[i].ylxx==='B类'){
                    zyArr2.push(zdzys[i]);
                }
            }
            this.detail.zdzyTitle1='A类';
            this.detail.zdzyTitle2='B类';
            this.detail.zdzys1=zyArr1;
            this.detail.zdzys2=zyArr2;
            this.detail.ylxks=res.data.obj.zdzys;
            this.detail.szdqmc=res.data.obj.yxml.szdqmc;
            this.detail.dh=res.data.obj.yxml.dh;
            this.detail.dzyx=res.data.obj.yxml.dzyj;
            this.detail.zswz=res.data.obj.yxml.zswz;
            this.detail.zszc=res.data.obj.yxml.zszc;
            this.detail.yymc=res.data.obj.yxml.yxywmc;
            this.detail.sf985=res.data.obj.yxml.sf985;
            this.detail.sf211=res.data.obj.yxml.sf211;
            this.detail.sfsyl=res.data.obj.yxml.sfsyl;
            this.detail.yfyjsy=res.data.obj.yxml.yfyjsy;
            this.detail.sf101=res.data.obj.yxml.sf101;
            this.detail.gbdm=res.data.obj.yxml.gbdm;
            this.detail.xxlb=res.data.obj.yxml.xxlb;
            this.detail.xxlbmc=res.data.obj.yxml.xxlbmc;
            this.detail.ylxkSize=res.data.obj.zdzysSize;
            this.detail.yxxh=res.data.obj.yxxhStr;
            this.detail.pc=pc;
            for(let i=1;i<7;i++){
                if(res.data.obj['zydh'+i]){
                    selectZydhData.push(res.data.obj['zydh'+i]);
                }
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }else if(res.data.msg){
                this.$message({message:res.data.msg,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        if(zyz===''){
            zyz=null;
        }
        if(type===''){
            type=null
        }
        const res2=await this.$http.postHttp("/yxcx/getLqxq",{
            kl:this.userInfo.kl,
            pc,
            yxxh,
            zxkma:this.userInfo.zxkma,
            zxkmb:this.userInfo.zxkmb,
            zyz,
            condition:type
        });
        if(res2.data.code===200){
            // this.zyzTotals=res2.data.obj.zyzTotals[0];
            const len=res2.data.obj.zyzTotals.length;
            const zyzs=res2.data.obj.zyzTotals;
            for(let i=0;i<len;i++){
                const zyz=zyzs[i].zyz;
                const isSc=res2.data.obj.zyz[zyz].isSc;
                if(isSc){
                    zyzs[i].isSc=1;
                }else{
                    zyzs[i].isSc=0;
                }
            }
            if(len===1){
                // const isSc=res2.data.obj.zyz[zyzs[0].zyz].isSc;
                const isSc=res.data.obj.sfsc;
                if(isSc){
                    this.isSc=1;
                }else{
                    this.isSc=0;
                }
            }
            console.log(res2);
            this.zyzTotals.list=res2.data.obj.zyzTotals;
            // this.zyzTotals.zyz=res2.data.obj.zyz;
            // this.zyzRowspan=res2.data.obj.zyzTotals[0].sub.length;
            // this.zyz=res2.data.obj.zyzTotals[0].zyz;
            if(res2.data.obj.zyzTotals[0]&&res2.data.obj.zyzTotals[0].zyz){
                this.zyz=res2.data.obj.zyzTotals[0].zyz;
            }
            if(zyzs[0]&&res2.data.obj.zyz[zyzs[0].zyz]){
                this.zyTotals=res2.data.obj.zyz[zyzs[0].zyz].zylb;
            }
            this.showYxObj={gbdm,zyz,pc,yxmc,yxxh,type};
            if(res2.data.obj.zyzTotals[0]&&res2.data.obj.zyzTotals[0].sub){
                this.zyzRowspan=res2.data.obj.zyzTotals[0].sub.length;
                this.showYxObj.sub=res2.data.obj.zyzTotals[0].sub;
            }else{
                this.$message({
                    type:'error',
                    message:"没有查到相关数据"
                });
            }
            const zybzs=[...this.zyTotals];
            const bzlen=zybzs.length;
            for(let i=0;i<bzlen;i++){
                if(zybzs[i]){
                    zybzs[i].isRed=false;
                }
            }
            for(let i=0;i<bzlen;i++){
                console.log(zybzs[i]);
                if(zybzs[i].zybz&&zybzs[i].zybz.indexOf("色盲")>=0&&zybzs[i].zybz.indexOf("色弱")>=0){
                    zybzs[i].isRed=true;
                }
            }
            this.zyTotals=zybzs;
            if(zyzs[0]&&res2.data.obj.zyz[zyzs[0].zyz]){
                const zyData=[];
                const zylb=res2.data.obj.zyz[zyzs[0].zyz].zylb;
                const zyLen=res2.data.obj.zyz[zyzs[0].zyz].zylb.length;
                for(let i=0;i<zyLen;i++){
                    const subs=zylb[i].subs;
                    for(let j=0;j<subs.length;j++){
                        console.log(subs[j]);
                        if(j%4===0){
                            let selectZydhIndex=-1;
                        for(let k=0;k<selectZydhData.length;k++){
                            if(subs[j].zydh===selectZydhData[k]){
                                selectZydhIndex=k;
                                break;
                            }
                        }
                        if(selectZydhIndex>=0){
                            subs[j].zyBtnTxt='专业'+(selectZydhIndex+1);
                        }else{
                            subs[j].zyBtnTxt="填报";
                        }
                        subs[j].isDisabled=false;
                        }
                        zyData.push(subs[j]);
                    }
                }
                console.log(zyData);
                this.zyData=zyData;
            }
            const schoolObj={};
            schoolObj.yxmc=yxmc;
            schoolObj.yxxh=yxxh;
            schoolObj.zyz=zyz;
            schoolObj.sb=null;
            schoolObj.pc=pc;
            schoolObj.sf985=this.detail.sf985;
            schoolObj.sf211=this.detail.sf211;
            schoolObj.snjhrs=0;
            schoolObj.jnjhrs=0;
            schoolObj.snrdwc=0;
            schoolObj.jnrdwc=0;
            schoolObj.tdx=0;
            schoolObj.zdtwf=0;
            schoolObj.pjtwf=0;
            schoolObj.zgtwf=0;
            schoolObj.sfsc=res2.data.obj.sfsc;
            for(let i=0;i<selectZydhData.length;i++){
              if(selectZydhData[i]){
                schoolObj['zy'+(i+1)]=selectZydhData[i];
              }
            }
            const schoolArr=[];
            schoolArr.push(schoolObj);
            console.log(schoolObj);
            this.schoolList=[...schoolArr];
            // this.zyzRowspan=4;
            // this.zyzTotals.jnjhs=res2.data.obj.zyzTotals[0].sub[0].jnjhs;
            // this.zyzTotals.sfsc=res2.data.obj.sfsc;
        }else if(res2.data.code===500){
            if(res2.data.message){
                this.$message({message:res2.data.message,type:"error"});
            }else if(res2.data.msg){
                this.$message({message:res2.data.msg,type:"error"});
            }
        }else if(res2.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res2.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        loading.close();
        loading2.close();
        this.$forceUpdate();
    },
    // 获取院校详情数据
    async getSchoolDeatil2(gbdm, zyz = null,pc,yxmc,yxxh,type=null){
        const loading=this.$loading({fullscreen:true,target:document.getElementById("lqTab"),text:"正在加载中"});
        // let { gbdm, zyz = null,pc,yxmc,yxxh,type=null } = this.$route.query;
        const res=await this.$http.postHttp("/yxcx/getYxDetail",{
            gbdm,
            zyz,
            pc,
            yxmc,
            yxxh
        });
        if(res.data.code===200){
            this.detail.logo=res.data.obj.yxml.logo;
            this.detail.dz=res.data.obj.yxml.dz;
            this.detail.wz=res.data.obj.yxml.xxwz;
            this.detail.yxmc=res.data.obj.yxmcStr;
            this.detail.jj=res.data.obj.yxml.jj;
            this.detail.jxsj=res.data.obj.yxml.jxsj;
            this.detail.ls=res.data.obj.yxml.ls;
            this.detail.xsrs=res.data.obj.yxml.xsrs;
            this.detail.bsdgs=res.data.obj.yxml.bsdgs;
            this.detail.ysrs=res.data.obj.yxml.ysrs;
            this.detail.ssdgs=res.data.obj.yxml.ssdgs;
            this.detail.nsbl=res.data.obj.yxml.nsbfb;
            this.detail.nvsbl=res.data.obj.yxml.nvsbfb;
            this.detail.xfxx=res.data.obj.yxml.xfxx;
            this.detail.jyqk=res.data.obj.yxml.jyqk;
            const zdzys=[...res.data.obj.zdzys];
            const zyArr1=[];
            const zyArr2=[];
            for(let i=0;i<zdzys.length;i++){
                if(zdzys[i].ylxx==='A类'){
                    zyArr1.push(zdzys[i]);
                }else if(zdzys[i].ylxx==='B类'){
                    zyArr2.push(zdzys[i]);
                }
            }
            this.detail.zdzyTitle1='A类';
            this.detail.zdzyTitle2='B类';
            this.detail.zdzys1=zyArr1;
            this.detail.zdzys2=zyArr2;
            this.detail.ylxks=res.data.obj.zdzys;
            this.detail.szdqmc=res.data.obj.yxml.szdqmc;
            this.detail.dh=res.data.obj.yxml.dh;
            this.detail.dzyx=res.data.obj.yxml.dzyj;
            this.detail.zswz=res.data.obj.yxml.zswz;
            this.detail.zszc=res.data.obj.yxml.zszc;
            this.detail.yymc=res.data.obj.yxml.yxywmc;
            this.detail.sf985=res.data.obj.yxml.sf985;
            this.detail.sf211=res.data.obj.yxml.sf211;
            this.detail.sfsyl=res.data.obj.yxml.sfsyl;
            this.detail.yfyjsy=res.data.obj.yxml.yfyjsy;
            this.detail.sf101=res.data.obj.yxml.sf101;
            this.detail.gbdm=res.data.obj.yxml.gbdm;
            this.detail.xxlb=res.data.obj.yxml.xxlb;
            this.detail.xxlbmc=res.data.obj.yxml.xxlbmc;
            this.detail.ylxkSize=res.data.obj.zdzysSize;
            this.detail.yxxh=res.data.obj.yxxhStr;
            this.detail.pc=pc;
            this.detail.lx=type;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }else if(res.data.msg){
                this.$message({message:res.data.msg,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        if(zyz===""){
            zyz=null;
        }
        if(type===''){
            type=null;
        }
        this.condition=type;
        const res2=await this.$http.postHttp("/yxcx/getLqxq",{
            kl:this.userInfo.kl,
            pc,
            yxxh,
            zxkma:this.userInfo.zxkma,
            zxkmb:this.userInfo.zxkmb,
            zyz,
            condition:type
        });
        if(res2.data.code===200){
            // this.zyzTotals=res2.data.obj.zyzTotals[0];
            const len=res2.data.obj.zyzTotals.length;
            const zyzs=res2.data.obj.zyzTotals;
            for(let i=0;i<len;i++){
                const zyz=zyzs[i].zyz;
                const isSc=res2.data.obj.zyz[zyz].isSc;
                if(isSc){
                    zyzs[i].isSc=1;
                }else{
                    zyzs[i].isSc=0;
                }
            }
            const data2=[...res2.data.obj.zyzTotals];
            console.log(data2);
            for(let i=0;i<data2.length;i++){
                console.log(data2[i]);
                if(data2[i]){
                    const subs=data2[i].sub;
                    for(let j=0;j<subs.length;j++){
                        if(j%4===0){
                            console.log(subs[j]);
                            if(data2[i].zyz===this.showYxObj.zyz){
                                subs[j].isCanDisabled=false;
                                subs[j].isShowZyzDetail=true;
                            }else{
                                subs[j].isCanDisabled=false;
                                subs[j].isShowZyzDetail=false;
                            }
                        }
                    }
                }
            }
            // for(let i=0;i<data2.length;i++){
            //     data2[i].isShowZyzDetail=false;
            //     data2[i].isCanDisabled=false;
            // }
            this.zyzTotals.list=data2;
            if(res2.data.obj.zyzTotals[0]&&res2.data.obj.zyzTotals[0].sub){
                this.zyzRowspan=res2.data.obj.zyzTotals[0].sub.length;
            }else{
                this.$message({
                    type:'error',
                    message:"没有查到相关数据"
                });
            }
            // this.zyzTotals.zyz=res2.data.obj.zyz;
            // this.zyzRowspan=4;
            // this.zyzTotals.jnjhs=res2.data.obj.zyzTotals[0].sub[0].jnjhs;
            // this.zyzTotals.sfsc=res2.data.obj.sfsc;
        }else if(res2.data.code===500){
            if(res2.data.message){
                this.$message({message:res2.data.message,type:"error"});
            }else if(res2.data.msg){
                this.$message({message:res2.data.msg,type:"error"});
            }
        }else if(res2.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res2.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        loading.close();
    },
    // 获取院校专业组详情数据
    async getZyzDeatil2(gbdm, zyz = null,pc,yxmc,yxxh,type=null){
        const loading=this.$loading({fullscreen:true,target:document.getElementById("lqTab"),text:"正在加载中"});
        const loading2=this.$loading({fullscreen:true,target:document.getElementById("zyData"),text:"正在加载中"});
        // const { gbdm, zyz = null,pc,yxmc,yxxh,type=null } = this.$route.query;
        const res=await this.$http.postHttp("/yxcx/getYxZyzDetail",{
            gbdm,
            zyz,
            pc,
            yxmc,
            yxxh
        });
        const selectZydhData=[];
        if(res.data.code===200){
            this.detail.logo=res.data.obj.yxml.logo;
            this.detail.dz=res.data.obj.yxml.dz;
            this.detail.wz=res.data.obj.yxml.xxwz;
            this.detail.yxmc=res.data.obj.yxmcStr;
            this.detail.jj=res.data.obj.yxml.jj;
            this.detail.jxsj=res.data.obj.yxml.jxsj;
            this.detail.ls=res.data.obj.yxml.ls;
            this.detail.xsrs=res.data.obj.yxml.xsrs;
            this.detail.bsdgs=res.data.obj.yxml.bsdgs;
            this.detail.ysrs=res.data.obj.yxml.ysrs;
            this.detail.ssdgs=res.data.obj.yxml.ssdgs;
            this.detail.nsbl=res.data.obj.yxml.nsbfb;
            this.detail.nvsbl=res.data.obj.yxml.nvsbfb;
            this.detail.xfxx=res.data.obj.yxml.xfxx;
            this.detail.jyqk=res.data.obj.yxml.jyqk;
            const zdzys=[...res.data.obj.zdzys];
            const zyArr1=[];
            const zyArr2=[];
            for(let i=0;i<zdzys.length;i++){
                if(zdzys[i].ylxx==='A类'){
                    zyArr1.push(zdzys[i]);
                }else if(zdzys[i].ylxx==='B类'){
                    zyArr2.push(zdzys[i]);
                }
            }
            this.detail.zdzyTitle1='A类';
            this.detail.zdzyTitle2='B类';
            this.detail.zdzys1=zyArr1;
            this.detail.zdzys2=zyArr2;
            this.detail.ylxks=res.data.obj.zdzys;
            this.detail.szdqmc=res.data.obj.yxml.szdqmc;
            this.detail.dh=res.data.obj.yxml.dh;
            this.detail.dzyx=res.data.obj.yxml.dzyj;
            this.detail.zswz=res.data.obj.yxml.zswz;
            this.detail.zszc=res.data.obj.yxml.zszc;
            this.detail.yymc=res.data.obj.yxml.yxywmc;
            this.detail.sf985=res.data.obj.yxml.sf985;
            this.detail.sf211=res.data.obj.yxml.sf211;
            this.detail.sfsyl=res.data.obj.yxml.sfsyl;
            this.detail.yfyjsy=res.data.obj.yxml.yfyjsy;
            this.detail.sf101=res.data.obj.yxml.sf101;
            this.detail.gbdm=res.data.obj.yxml.gbdm;
            this.detail.xxlb=res.data.obj.yxml.xxlb;
            this.detail.xxlbmc=res.data.obj.yxml.xxlbmc;
            this.detail.ylxkSize=res.data.obj.zdzysSize;
            this.detail.yxxh=res.data.obj.yxxhStr;
            this.detail.pc=pc;
            for(let i=1;i<7;i++){
                if(res.data.obj['zydh'+i]){
                    selectZydhData.push(res.data.obj['zydh'+i]);
                }
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }else if(res.data.msg){
                this.$message({message:res.data.msg,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        if(zyz===''){
            zyz=null;
        }
        if(type===''){
            type=null
        }
        const res2=await this.$http.postHttp("/yxcx/getLqxq",{
            kl:this.userInfo.kl,
            pc,
            yxxh,
            zxkma:this.userInfo.zxkma,
            zxkmb:this.userInfo.zxkmb,
            zyz,
            condition:type
        });
        if(res2.data.code===200){
            // this.zyzTotals=res2.data.obj.zyzTotals[0];
            const len=res2.data.obj.zyzTotals.length;
            const zyzs=res2.data.obj.zyzTotals;
            for(let i=0;i<len;i++){
                const zyz=zyzs[i].zyz;
                const isSc=res2.data.obj.zyz[zyz].isSc;
                if(isSc){
                    zyzs[i].isSc=1;
                }else{
                    zyzs[i].isSc=0;
                }
            }
            if(len===1){
                // const isSc=res2.data.obj.zyz[zyzs[0].zyz].isSc;
                const isSc=res.data.obj.sfsc;
                if(isSc){
                    this.isSc=1;
                }else{
                    this.isSc=0;
                }
            }
            console.log(res2);
            this.zyzTotals.list=res2.data.obj.zyzTotals;
            // this.zyzTotals.zyz=res2.data.obj.zyz;
            this.zyzRowspan=res2.data.obj.zyzTotals[0].sub.length;
            this.zyz=res2.data.obj.zyzTotals[0].zyz;
            this.zyTotals=res2.data.obj.zyz[zyzs[0].zyz].zylb;
            const zybzs=[...this.zyTotals];
            const bzlen=zybzs.length;
            for(let i=0;i<bzlen;i++){
                if(zybzs[i]){
                    zybzs[i].isRed=false;
                }
            }
            for(let i=0;i<bzlen;i++){
                console.log(zybzs[i]);
                if(zybzs[i].zybz&&zybzs[i].zybz.indexOf("色盲")>=0&&zybzs[i].zybz.indexOf("色弱")>=0){
                    zybzs[i].isRed=true;
                }
            }
            this.zyTotals=zybzs;
            const zyData=[];
            const zylb=res2.data.obj.zyz[zyzs[0].zyz].zylb;
            const zyLen=res2.data.obj.zyz[zyzs[0].zyz].zylb.length;
            for(let i=0;i<zyLen;i++){
                const subs=zylb[i].subs;
                for(let j=0;j<subs.length;j++){
                    console.log(subs[j]);
                    if(j%4===0){
                        let selectZydhIndex=-1;
                      for(let k=0;k<selectZydhData.length;k++){
                        if(subs[j].zydh===selectZydhData[k]){
                            selectZydhIndex=k;
                            break;
                        }
                      }
                      if(selectZydhIndex>=0){
                        subs[j].zyBtnTxt='专业'+(selectZydhIndex+1);
                      }else{
                        subs[j].zyBtnTxt="填报";
                      }
                      subs[j].isDisabled=false;
                    }
                    zyData.push(subs[j]);
                }
            }
            console.log(zyData);
            this.zyData=zyData;
            const schoolObj={};
            schoolObj.yxmc=yxmc;
            schoolObj.yxxh=yxxh;
            schoolObj.zyz=zyz;
            schoolObj.sb=null;
            schoolObj.pc=pc;
            schoolObj.sf985=this.detail.sf985;
            schoolObj.sf211=this.detail.sf211;
            schoolObj.snjhrs=0;
            schoolObj.jnjhrs=0;
            schoolObj.snrdwc=0;
            schoolObj.jnrdwc=0;
            schoolObj.tdx=0;
            schoolObj.zdtwf=0;
            schoolObj.pjtwf=0;
            schoolObj.zgtwf=0;
            schoolObj.sfsc=res2.data.obj.sfsc;
            for(let i=0;i<selectZydhData.length;i++){
              if(selectZydhData[i]){
                schoolObj['zy'+(i+1)]=selectZydhData[i];
              }
            }
            const schoolArr=[];
            schoolArr.push(schoolObj);
            console.log(schoolObj);
            this.schoolList=[...schoolArr];
            // this.zyzRowspan=4;
            // this.zyzTotals.jnjhs=res2.data.obj.zyzTotals[0].sub[0].jnjhs;
            // this.zyzTotals.sfsc=res2.data.obj.sfsc;
        }else if(res2.data.code===500){
            if(res2.data.message){
                this.$message({message:res2.data.message,type:"error"});
            }else if(res2.data.msg){
                this.$message({message:res2.data.msg,type:"error"});
            }
        }else if(res2.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res2.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        loading.close();
        loading2.close();
        this.$forceUpdate();
    },
    // 关闭当前页面
    closeWin() {
                const userAgent = navigator.userAgent;
                if (userAgent.indexOf("Firefox") !== -1 || userAgent.indexOf("Chrome") !== -1) {
                    window.open('','_self').close();
                }else {
                    window.opener = null;
                    window.open("about:blank", "_self");
                    window.close();
                }
    },
    // 跳转到专业组详情
    toZyzDetail(gbdm,yxxh,yxmc,zyz,pc,lx){
        this.$store.commit('initIsUpdateToken');
        const url=this.$router.resolve({
            path:"/main/zyzDetail",
            query:{
                gbdm,
                yxxh,
                yxmc,
                zyz,
                pc,
                type:lx
            }
        });
        window.open(url.href,"_self");
    },
    async toZyzDetail2(gbdm, zyz = null,pc,yxmc,yxxh,type=null,obj){
        const list=[...this.zyzTotals.list];
        let index=0;
        let index3=0
        obj.zyz=zyz;
        for(let i=0;i<list.length;i++){
            if(list[i].zyz===obj.zyz){
                index=i;
                break;
            }
        }
        list[index].sub[index3].isCanDisabled=true;
        this.zyzTotals.list=list;
        await this.getZyzDetail(gbdm,zyz,pc,yxmc,yxxh,type,obj);
        if(!list[index].sub[index3].isShowZyzDetail){
        for(let i=0;i<list.length;i++){
            if(list[i]&&list[i].sub){
                const subs=list[i].sub;
                if(subs[0]){
                    subs[0].isShowZyzDetail=false;
                }
            }
        }
            list[index].sub[index3].isShowZyzDetail=true;
        }else{
            list[index].sub[index3].isShowZyzDetail=false;
        }
        list[index].sub[index3].isCanDisabled=false;
        this.showYxObj={...obj};
        this.zyzTotals.list=list;
    },
    async getZyzDetail(gbdm, zyz = null,pc,yxmc,yxxh,type=null,obj){
            const res=await this.$http.postHttp("/yxcx/getYxZyzDetail",{
                gbdm,
                zyz,
                pc,
                yxmc,
                yxxh
            });
            console.log(res);
            const selectZydhData=[];
            if(res.data.code===200){
                this.detail2.logo=res.data.obj.yxml.logo;
                this.detail2.dz=res.data.obj.yxml.dz;
                this.detail2.wz=res.data.obj.yxml.xxwz;
                this.detail2.yxmc=res.data.obj.yxmcStr;
                this.detail2.jj=res.data.obj.yxml.jj;
                this.detail2.jxsj=res.data.obj.yxml.jxsj;
                this.detail2.ls=res.data.obj.yxml.ls;
                this.detail2.xsrs=res.data.obj.yxml.xsrs;
                this.detail2.bsdgs=res.data.obj.yxml.bsdgs;
                this.detail2.ysrs=res.data.obj.yxml.ysrs;
                this.detail2.ssdgs=res.data.obj.yxml.ssdgs;
                this.detail2.nsbl=res.data.obj.yxml.nsbfb;
                this.detail2.nvsbl=res.data.obj.yxml.nvsbfb;
                this.detail2.xfxx=res.data.obj.yxml.xfxx;
                this.detail2.jyqk=res.data.obj.yxml.jyqk;
                this.detail2.ylxks=res.data.obj.zdzys;
                this.detail2.szdqmc=res.data.obj.yxml.szdqmc;
                this.detail2.dh=res.data.obj.yxml.dh;
                this.detail2.dzyx=res.data.obj.yxml.dzyj;
                this.detail2.zswz=res.data.obj.yxml.zswz;
                this.detail2.zszc=res.data.obj.yxml.zszc;
                this.detail2.yymc=res.data.obj.yxml.yxywmc;
                this.detail2.sf985=res.data.obj.yxml.sf985;
                this.detail2.sf211=res.data.obj.yxml.sf211;
                this.detail2.sfsyl=res.data.obj.yxml.sfsyl;
                this.detail2.yfyjsy=res.data.obj.yxml.yfyjsy;
                this.detail2.sf101=res.data.obj.yxml.sf101;
                this.detail2.gbdm=res.data.obj.yxml.gbdm;
                this.detail2.xxlb=res.data.obj.yxml.xxlb;
                this.detail2.xxlbmc=res.data.obj.yxml.xxlbmc;
                this.detail2.ylxkSize=res.data.obj.zdzysSize;
                this.detail2.yxxh=res.data.obj.yxxhStr;
                this.detail2.pc=pc;
                for(let i=1;i<7;i++){
                    if(res.data.obj['zydh'+i]){
                        selectZydhData.push(res.data.obj['zydh'+i]);
                    }
                }
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:"error"});
                }else if(res.data.msg){
                    this.$message({message:res.data.msg,type:"error"});
                }
            }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.status===409||res.status===410||res.status===411){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
            if(zyz===''){
                zyz=null;
            }
            if(type===''){
                type=null
            }
            const res2=await this.$http.postHttp("/yxcx/getLqxq",{
                kl:this.userInfo.kl,
                pc,
                yxxh,
                zxkma:this.userInfo.zxkma,
                zxkmb:this.userInfo.zxkmb,
                zyz,
                condition:type
            });
            if(res2.data.code===200){
                // this.zyzTotals=res2.data.obj.zyzTotals[0];
                const len=res2.data.obj.zyzTotals.length;
                const zyzs=res2.data.obj.zyzTotals;
                for(let i=0;i<len;i++){
                    const zyz=zyzs[i].zyz;
                    const isSc=res2.data.obj.zyz[zyz].isSc;
                    if(isSc){
                        zyzs[i].isSc=1;
                    }else{
                        zyzs[i].isSc=0;
                    }
                }
                if(len===1){
                    const isSc=res2.data.obj.zyz[zyzs[0].zyz].isSc;
                    if(isSc){
                        this.isSc2=1;
                    }else{
                        this.isSc2=0;
                    }
                }
                console.log(res2);
                this.zyzTotals2.list=res2.data.obj.zyzTotals;
                // this.zyzTotals.zyz=res2.data.obj.zyz;
                this.zyzRowspan2=res2.data.obj.zyzTotals[0].sub.length;
                this.zyz2=res2.data.obj.zyzTotals[0].zyz;
                this.zyTotals2=res2.data.obj.zyz[zyzs[0].zyz].zylb;
                const zybzs=[...this.zyTotals2];
                const bzlen=zybzs.length;
                for(let i=0;i<bzlen;i++){
                    if(zybzs[i]){
                        zybzs[i].isRed=false;
                    }
                }
                for(let i=0;i<bzlen;i++){
                    console.log(zybzs[i]);
                    if(zybzs[i].zybz&&zybzs[i].zybz.indexOf("色盲")>=0&&zybzs[i].zybz.indexOf("色弱")>=0){
                        zybzs[i].isRed=true;
                    }
                }
                this.zyTotals2=zybzs;
                const zyData=[];
                const zylb=res2.data.obj.zyz[zyzs[0].zyz].zylb;
                const zyLen=res2.data.obj.zyz[zyzs[0].zyz].zylb.length;
                for(let i=0;i<zyLen;i++){
                    const subs=zylb[i].subs;
                    for(let j=0;j<subs.length;j++){
                        if(j%4===0){
                            let selectZydhIndex=-1;
                            for(let k=0;k<selectZydhData.length;k++){
                                if(subs[j].zydh===selectZydhData[k]){
                                    selectZydhIndex=k;
                                    break;
                                }
                            }
                            if(selectZydhIndex>=0){
                                subs[j].zyBtnTxt='专业'+(selectZydhIndex+1);
                            }else{
                                subs[j].zyBtnTxt="填报";
                            }
                        }
                        subs[j].btnRightTopNum=0;
                        zyData.push(subs[j]);
                    }
                }
                console.log(zyData);
                this.zyData2=zyData;
                const schoolObj={};
                schoolObj.yxmc=yxmc;
                schoolObj.yxxh=yxxh;
                schoolObj.zyz=zyz;
                schoolObj.sb=null;
                schoolObj.pc=pc;
                schoolObj.sf985=this.detail.sf985;
                schoolObj.sf211=this.detail.sf211;
                schoolObj.snjhrs=0;
                schoolObj.jnjhrs=0;
                schoolObj.snrdwc=0;
                schoolObj.jnrdwc=0;
                schoolObj.tdx=0;
                schoolObj.zdtwf=0;
                schoolObj.pjtwf=0;
                schoolObj.zgtwf=0;
                schoolObj.sfsc=res2.data.obj.sfsc;
                for(let i=0;i<selectZydhData.length;i++){
                if(selectZydhData[i]){
                    schoolObj['zy'+(i+1)]=selectZydhData[i];
                }
                }
                const schoolArr=[];
                schoolArr.push(schoolObj);
                console.log(schoolObj);
                this.schoolList=[...schoolArr];
                // this.zyzRowspan=4;
                // this.zyzTotals.jnjhs=res2.data.obj.zyzTotals[0].sub[0].jnjhs;
                // this.zyzTotals.sfsc=res2.data.obj.sfsc;
            }else if(res2.data.code===500){
                if(res2.data.message){
                    this.$message({message:res2.data.message,type:"error"});
                }else if(res2.data.msg){
                    this.$message({message:res2.data.msg,type:"error"});
                }
            }else if(res2.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res2.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }
            this.$forceUpdate();
    },
    // 去除HTML标签，提取其中的文字
    highlight(item){
        return item.replace(/<[^>]+>/g, '');
    },
    chooseZy(obj){
        console.log(obj);
    },
    // 获取招生章程
    async getZszc(){
        const res=await this.$http.getHttp("/yxcx/getZszc?gbdm="+this.detail.gbdm);
        console.log(res.data);
        if(res.data.code===200){
            if(res.data.obj){
                if(res.data.obj==="<br />"){
                    this.detail.zszc="暂无招生章程!";
                }else{
                    this.detail.zszc=res.data.obj;
                }
            }else {
                this.detail.zszc="暂无招生章程!";
            }
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginout",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    // 查看简介和收起简介
    watchAndStop(){
        const maxwidth=this.maxwidth;
        const txt=this.detail.jj;
        if(txt.length-7<=maxwidth){
            this.detail.jj=this.detail.lsjj;
            this.detailTxt="<< 收起详情";
        }else{
            this.detail.jj=txt.substring(0,maxwidth)+".......";
            this.detailTxt="查看详情 >>";
        }
    },
    // 获取已经收藏的院校专业组个数
    async getYxzyz(){
        const { pc } = this.$route.query;
        const res=await this.$http.postHttp("/yhgz/selectYhgzYx",{
            fs:this.userInfo.gkfs,
            kl:this.userInfo.kl,
            xm:this.userInfo.xm,
            yhid:this.userInfo.yhid,
            pc
        });
        if(res.data.code===200){
            this.scZyzSize=res.data.obj.length;
            this.xh=res.data.obj.length;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:'error'});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    // 跳转到专业详情页面
    toZyDetail(zydm){
        const a=true;
        if(a){
            return;
        }
        this.$store.commit('initIsUpdateToken');
        const url=this.$router.resolve({
            path:"/main/majorDetail",
            query:{zydm}
        });
        window.open(url.href,"_blank");
    },
    // 跨行
    objectSpanMethod({row, column, rowIndex, columnIndex }){
        if(columnIndex===0||columnIndex===1||columnIndex===11||columnIndex===12){
            if(rowIndex%4===0){
                return{
                    rowspan:4,
                    colspan:1
                };
            }else {
                return {
                    rowspan:0,
                    colspan:0
                };
            }
        }
    },
    objectCellMethod({row,column,rowIndex,columnIndex}){
        if(rowIndex%4===3&&columnIndex===7){
            return{'border':'1px solid #09F','text-align':'center','color':'#ED4A09','font-weight':'bold'};
        }else{
            return{'border':'1px solid #09F','text-align':'center'};
        }
    },
    async addSchoolList(obj,item,addType){
    const yxmc=item.yxmc||obj.yxmc||this.detail.yxmc;
    const sb=item.sb||obj.sb||"";
    const zyz=item.zyz||obj.zyz||"";
    const yxxh=item.yxxh||obj.yxxh||"";
    const pc=item.pc||obj.pc||0;
    const sf985=item.sf985||obj.sf985||0;
    const sf211=item.sf211||obj.sf211||0;
    const sfsyl=item.sfsyl||obj.sfsyl||0;
    const sfyjsy=item.sfyjsy||obj.sfyjsy||0;
    const snjhrs=item.wnjhs||item.wnjhs||0;
    const jnjhrs=item.jnjhs||obj.jnjhs||0;
    let snrdwc=0;
    let jnrdwc=0;
    console.log(item);
    const subs=[...item.sub];
    let nds=[];
    for(let i=0;i<subs.length;i++){
        if(subs[i].nd>0){
        nds.push(subs[i].nd);
        }
    }
    nds=[...(new Set(nds))].sort(function(a,b){
    return b-a;
    });
    let tdx=0;
    let zdtwf=0;
    let pjtwf=0;
    let zgtwf=0;
    const nd1=nds[0];
    const nd2=nds[1];
    for(let i=0;i<subs.length;i++){
        if(subs[i].nd===nd1){
        jnrdwc=subs[i].rdwc;
        tdx=subs[i].tdx;
        zdtwf=subs[i].zdtwf;
        zgtwf=subs[i].zgtwf;
        pjtwf=subs[i].pjtwf;
        }else if(subs[i].nd===nd2){
        snrdwc=subs[i].rdwc;
        }
    }
    const zyData=[...(addType==='1'?this.zyData:this.zyData2)];
    let index=0;
    for(let i=0;i<zyData.length;i++){
        if(zyData[i].zymc===obj.zymc){
            index=i;
            break;
        }
    }
    if(addType==='1'){
        const data=[...this.zyData];
        data.forEach((item)=>{
            item.isDisabled=true;
        });
        this.zyData=data;
    }else{
        const data=[...this.zyData2];
        data.forEach((item)=>{
            item.isDisabled=true;
        });
        this.zyData2=data;
    }
    // this.$set((addType==='1'?this.zyData[index]:this.zyData2[index]),'isDisabled',true);
    const schoolObj={};
    schoolObj.yxmc=yxmc;
    schoolObj.yxxh=yxxh;
    schoolObj.zyz=zyz;
    schoolObj.sb=sb;
    schoolObj.pc=pc;
    schoolObj.sf985=sf985;
    schoolObj.sf211=sf211;
    schoolObj.snjhrs=snjhrs;
    schoolObj.jnjhrs=jnjhrs;
    schoolObj.snrdwc=snrdwc;
    schoolObj.jnrdwc=jnrdwc;
    schoolObj.tdx=tdx;
    schoolObj.zdtwf=zdtwf;
    schoolObj.pjtwf=pjtwf;
    schoolObj.zgtwf=zgtwf;
    const schoolList=[...this.schoolList];
    console.log(schoolList);
    let index2=0;
    for(let i=0;i<schoolList.length;i++){
        if(schoolList[i].yxmc===item.yxmc&&schoolList[i].zyz===item.zyz){
        index2=i;
        break;
        }
    }
    let count=0;
    let existFlag=false;
    let zyIndex=0;
    for(let i=1;i<7;i++){
        if(schoolList[index2]&&schoolList[index2]['zy'+i]&&schoolList[index2].yxmc===item.yxmc){
        if((schoolList[index2]['zy'+i]===obj.zydh)
        ||(schoolList[index2]['zy'+i]===obj.zydm)){
            existFlag=true;
            zyIndex=i;
        }
            count++;
        }
    }
    if(count===6&&!existFlag){
        this.$message({message:'每个志愿最多填报6个专业',type:'warning',showClose:true});
        // this.$set((addType==='1'?this.zyData[index]:this.zyData2[index]),'isDisabled',false);
        
        if(addType==='1'){
            const data=[...this.zyData];
            data.forEach((item)=>{
                item.isDisabled=false;
            });
            this.zyData=data;
        }else{
            const data=[...this.zyData2];
            data.forEach((item)=>{
                item.isDisabled=false;
            });
            this.zyData2=data;
        }
        return;
    }else if(count>=0&&count<6&&!existFlag){
        // zyData[index].zyBtnTxt='专业'+(count+1);
        this.$set((addType==='1'?this.zyData[index]:this.zyData2[index]),'zyBtnTxt','专业'+(count+1));
    }else if(existFlag){
        zyData[index].zyBtnTxt='填报';
        schoolList[index2]['zy'+zyIndex]='';
        schoolList[index2]['zymc'+zyIndex]='';
    }
    if(!existFlag&&count>=0&&count<6){
        schoolObj['zy'+(count+1)]=obj.zydh||obj.zydm;
        schoolObj['zymc'+(count+1)]=obj.zymc;
    }else{
        // 1 2 3 4 5 6-> 1 3 4 5 6->1 2 3 4 5
        // 1 2 3 4 5 6-> 1 2 4 5 6->1 2 3 4 6
        // 1 2 3 4 5 6-> 1 2 3 5 6->1 2 3 4 5
        // 1 2 3 4 5 6-> 1 2 3 5 6->1 2 3 4 5
        // 6 5 4 3 2 1-> 6 5 3 2 1 ->1 2 3 5 6->1 2 3 4 5-> 5 4 3 2 1
        let haveZyCount=0;
        const oldZyIndexArr=[];
        let newZyIndexArr=[];
        const oldSortIndexArr=[];
        const haveZyIndexArr=[];
        const zyObjArr=[];
        const haveZydhArr=[];
        const haveZymcArr=[];
        const newZydhArr=[];
        const newZymcArr=[];
        const schoolZyNumChangeArr=[];
        const pageTotal=(zyData.length)/4;
        const oldZyIndexArr2=[];
        let newZyIndexArr2=[];
        const oldSortIndexArr2=[];
        const haveZyIndexArr2=[];
        const oldZyNumArr=[];
        let newZyNumArr=[];
        const oldSortZyNumArr=[];
        const haveZyNumArr=[];
        const zyObjArr2=[];
        let zyNumChangeArr=[];
        const newZyNumChangeArr=[];
        zyData[index].zyBtnTxt='填报';
        for(let i=1;i<pageTotal+1;i++){
        const obj=zyData[i*4-4];
        if(obj.zyBtnTxt.indexOf('专业')>=0){
            oldZyIndexArr2.push(i*4-4);
            const zyNum=parseInt(obj.zyBtnTxt.split("专业")[1]);
            oldZyNumArr.push(zyNum);
            const obj2={};
            obj2.zyNum=zyNum;
            obj2.zyNumIndex=i*4-4;
            zyObjArr2.push(obj2);
        }
        }
        newZyNumArr=[...oldZyNumArr];
        newZyNumArr.sort((a,b)=>{
        return a-b;
        });
        for(let i=0;i<oldZyNumArr.length;i++){
        if(newZyNumArr[i]>1){
            if(oldSortZyNumArr.indexOf(newZyNumArr[i]-1)<0){
            oldSortZyNumArr.push(newZyNumArr[i]-1);
            }else{
            oldSortZyNumArr.push(newZyNumArr[i]);
            }
        }else{
            oldSortZyNumArr.push(1);
        }
        }
        console.log(zyObjArr2,oldSortZyNumArr);
        zyNumChangeArr=[...zyObjArr2];
        zyNumChangeArr.sort((a,b)=>{
        return a.zyNum-b.zyNum;
        });
        for(let i=0;i<zyNumChangeArr.length;i++){
        if(zyNumChangeArr[i].zyNum>1){
            let flag=false;
            for(let j=0;j<newZyNumChangeArr.length;j++){
            if(zyNumChangeArr[i].zyNum-1===newZyNumChangeArr[j].zyNum){
                flag=true;
                break;
            }
            }
            if(!flag){
            const obj={};
            obj.zyNum=zyNumChangeArr[i].zyNum-1;
            obj.zyNumIndex=zyNumChangeArr[i].zyNumIndex;
            newZyNumChangeArr.push(obj);
            }else{
            newZyNumChangeArr.push(zyNumChangeArr[i]);
            }
        }else{
            newZyNumChangeArr.push(zyNumChangeArr[i]);
        }
        }
        for(let i=0;i<newZyNumChangeArr.length;i++){
        if(newZyNumChangeArr[i]){
            zyData[newZyNumChangeArr[i].zyNumIndex].zyBtnTxt='专业'+newZyNumChangeArr[i].zyNum;
        }
        }
        for(let i=1;i<7;i++){
        if(schoolList[index2]['zy'+i]){
            haveZyCount++;
            oldZyIndexArr.push(i);
            const obj={};
            obj.zyNumIndex=index2;
            obj.zyNum=i;
            obj.zydh=schoolList[index2]['zy'+i];
            obj.zymc=schoolList[index2]['zymc'+i];
            zyObjArr.push(obj);
        }
        }
        newZyIndexArr=[...oldZyIndexArr];
        newZyIndexArr.sort((a,b)=>{
        return a-b;
        });
        for(let i=0;i<newZyIndexArr.length;i++){
        if(newZyIndexArr[i]>1){
            if(oldSortIndexArr.indexOf(newZyIndexArr[i]-1)<0){
            oldSortIndexArr.push(newZyIndexArr[i]-1);
            }else{
            oldSortIndexArr.push(newZyIndexArr[i]);
            }
        }else{
            oldSortIndexArr.push(1);
        }
        }
        console.log(oldSortIndexArr,zyObjArr);
        for(let i=0;i<zyObjArr.length;i++){
        for(let j=0;j<oldSortIndexArr.length;j++){
            if(zyObjArr[i].zyNum>1){
            if(zyObjArr[i].zyNum-1===oldSortIndexArr[j]){
                let flag=false;
                for(let a=0;a<schoolZyNumChangeArr.length;a++){
                if(schoolZyNumChangeArr[a].zyNum===zyObjArr[i].zyNum-1){
                    flag=true;
                    break;
                }
                }
                if(!flag){
                const obj={};
                obj.zyNum=oldSortIndexArr[j];
                obj.zydh=zyObjArr[i].zydh;
                obj.zymc=zyObjArr[i].zymc;
                schoolZyNumChangeArr.push(obj);
                }else{
                schoolZyNumChangeArr.push(zyObjArr[i]);
                }
            }
            }else{
            let flag=false;
            for(let k=0;k<schoolZyNumChangeArr.length;k++){
                if(schoolZyNumChangeArr[k].zyNum===zyObjArr[i].zyNum){
                flag=true;
                break;
                }
            }
            if(!flag){
                schoolZyNumChangeArr.push(zyObjArr[i]);
            }
            }
        }
        }
        for(let i=1;i<7;i++){
        if(schoolList[index2]){
            schoolList[index2]['zy'+i]=''
            schoolList[index2]['zymc'+i]='';
        }
        }
        console.log(schoolZyNumChangeArr);
        for(let i=0;i<schoolZyNumChangeArr.length;i++){
        if(schoolZyNumChangeArr[i]){
            schoolList[index2]['zy'+schoolZyNumChangeArr[i].zyNum]=schoolZyNumChangeArr[i].zydh;
            schoolList[index2]['zymc'+schoolZyNumChangeArr[i].zyNum]=schoolZyNumChangeArr[i].zymc;
        }
        }
    }
    if(!schoolList[index2]||(schoolList[index2].yxmc!==item.yxmc)){
        schoolObj['zy'+(count+1)]=obj.zydh||obj.zydm;
        schoolObj['zymc'+(count+1)]=obj.zymc;
        schoolList.push(schoolObj);
    }else if(schoolList[index2]&&!existFlag&&schoolList[index2].yxmc===item.yxmc){
        schoolList[index2]['zy'+(count+1)]=obj.zydh||obj.zydm;
        schoolList[index2]['zymc'+(count+1)]=obj.zymc;
    }
    console.log(schoolList);
    const res=await this.$http.postHttp("/yhgz/saveOrUpdateYhgzyxzyz",{
                yhid:this.userInfo.yhid,
                yxxh:schoolObj.yxxh,
                pc,
                kl:this.userInfo.sxkm,
                zyz:schoolObj.zyz,
                xm:this.userInfo.xm,
                fs:this.userInfo.gkfs+"",
                xh:"",
                gzsj:"",
                zydh1:schoolList[index2].zy1?schoolList[index2].zy1:'',
                zydh2:schoolList[index2].zy2?schoolList[index2].zy2:'',
                zydh3:schoolList[index2].zy3?schoolList[index2].zy3:'',
                zydh4:schoolList[index2].zy4?schoolList[index2].zy4:'',
                zydh5:schoolList[index2].zy5?schoolList[index2].zy5:'',
                zydh6:schoolList[index2].zy6?schoolList[index2].zy6:'',
                yxmc:schoolObj.yxmc
    });
    if(res.data.code===200){
        if(addType==='1'){
            this.zyData=zyData;
        }else{
            this.zyData2=zyData;
        }
        this.schoolList=schoolList;
        this.updateZyList=!this.updateZyList;
        if(addType==='1'){
            await this.getZyzDeatil2(this.showYxObj.gbdm,zyz,pc,yxmc,yxxh,this.showYxObj.type,this.showYxObj);
        }else{
            this.showYxObj.zyz=zyz;
            await this.getSchoolDeatil2(this.showYxObj.gbdm,null,pc,yxmc,yxxh,this.showYxObj.type,this.showYxObj);
            await this.getZyzDetail(this.showYxObj.gbdm,zyz,pc,yxmc,yxxh,this.showYxObj.type,this.showYxObj);
        }
        this.handleJj();
        
        if(addType==='1'){
            const data=[...this.zyData];
            data.forEach((item)=>{
                item.isDisabled=false;
            });
            this.zyData=data;
        }else{
            const data=[...this.zyData2];
            data.forEach((item)=>{
                item.isDisabled=false;
            });
            this.zyData2=data;
        }
        // this.$set((addType==='1'?this.zyData[index]:this.zyData2[index]),'isDisabled',false);
        this.$forceUpdate();
    }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
    }else if(res.status===401){
                this.$message({message: '登录超时，请重新登录',type:"error"});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
    }else if(res.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
    }else if(res.status===409||res.status===410||res.status===411){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
    }
    },
    getCellClass({row,column,columnIndex}){
        if(row%3===0&&columnIndex===7){
            return 'yuceTdx';
        }else{
            return '';
        }
    },
    // 用jQuery实现查看详情和收起详情
    // watchAndStop(){
    //     $('.inner .intro').each(function () {
    //                             var maxwidth = 300; // 设置最多显示的字数
    //                             var textTemp = $(this).text(); // 临时记录
    //                             if ($(this).text().length > maxwidth) {
    //                                 $(this).text($(this).text().substring(0, maxwidth) + ".......");
    //                                 $(".read-more a").text("查看详情 >>");
    //                             }
    //                             $(".read-more a").click(function () {
    //                                 var temp = $('.inner .intro');
    //                                 if (temp.text().length - 7 <= maxwidth) {
    //                                     temp.text(textTemp);
    //                                     $(this).text("<< 收起详情");
    //                                 } else {
    //                                     temp.text(temp.text().substring(0, maxwidth) + ".......");
    //                                     $(this).text("查看详情 >>");
    //                                 }
    //                             });
    //                         });
    // },
    handleJj(){
        this.detail.jj=this.highlight(this.detail.jj);
        this.detail.lsjj=this.highlight(this.detail.jj);
        const maxwidth=this.maxwidth;
        let txt=this.detail.jj;
        if(txt.length>maxwidth){
            txt=txt.substring(0,maxwidth)+".......";
        }
        this.detail.jj=txt;
    },
    // 跳转学校外部链接
    goSchoolLink(link){
        window.open(link,'_blank');
    },
    // 加入收藏
    // 关注院校
    async addCollect(zyz,status,addType){
        const { pc,yxxh } = this.$route.query;
        if(this.collectLoading){
            return;
        }
        this.collectLoading=true;
        const res=await this.$http.postHttp("/yhgz/addGzYxZyz",{
            yhid:this.userInfo.yhid,
            yxxh,
            pc,
            kl:this.userInfo.sxkm,
            zyz,
            xm:this.userInfo.xm,
            fs:this.userInfo.gkfs+"",
            xh:"",
            status,
            gzsj:""
        });
        if(res.data.code===200){
            // await this.getYxzyz();
            const num=res.data.obj;
            if(res.data.message){
                const msg=res.data.message+'，共收藏 '+num+' 所院校专业组';
                this.$message({type:"success",message:msg,showClose:true});
                if(addType==='1'){
                    await this.getZyzDeatil2(this.showYxObj.gbdm,zyz,pc,this.showYxObj.yxmc,yxxh,this.showYxObj.type,this.showYxObj);
                    this.$forceUpdate();
                }else{
                    this.showYxObj.zyz=zyz;
                    await this.getSchoolDeatil2(this.showYxObj.gbdm,null,pc,this.showYxObj.yxmc,yxxh,this.showYxObj.type,this.showYxObj);
                    await this.getZyzDetail(this.showYxObj.gbdm,zyz,pc,this.showYxObj.yxmc,yxxh,this.showYxObj.type,this.showYxObj);
                    this.$forceUpdate();
                }
            }else{
                const msg='操作成功'+'，共收藏 '+num+' 所院校专业组';
                this.$message({type:"success",message:msg,showClose:true});
                if(addType==='1'){
                    await this.getZyzDeatil2(this.showYxObj.gbdm,zyz,pc,this.showYxObj.yxmc,yxxh,this.showYxObj.type,this.showYxObj);
                    this.$forceUpdate();
                }else{
                    this.showYxObj.zyz=zyz;
                    await this.getSchoolDeatil2(this.showYxObj.gbdm,null,pc,this.showYxObj.yxmc,yxxh,this.showYxObj.type,this.showYxObj);
                    await this.getZyzDetail(this.showYxObj.gbdm,zyz,pc,this.showYxObj.yxmc,yxxh,this.showYxObj.type,this.showYxObj)
                    this.$forceUpdate();
                }
            }
            this.handleJj();
        }else if(res.data.code===500){
            this.$message({message:res.data.message,type:"error"});
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
        // const type=this.type;
        // if(type==="1"){
        //     const list=this.zyzTotals.list;
        //     for(let i=0;i<list.length;i++){
        //         if(list[i].zyz===zyz){
        //             const isSc=list[i].isSc;
        //             if(isSc===0){
        //                 list[i].isSc=1;
        //             }else{
        //                 list[i].isSc=0;
        //             }
        //         }
        //     }
        // }else if(type==="2"){
        //     const isSc=this.isSc;
        //     if(isSc===0){
        //         this.isSc=1;
        //     }else{
        //         this.isSc=0;
        //     }
        // }
        // this.$forceUpdate();
        this.collectLoading=false;
        // const type=this.type;
        // if(type==="1"){
        //     await this.getSchoolDeatil();
        // }else if(type==="2"){
        //     await this.getZyzDeatil();
        // }
        // this.$forceUpdate();
    }
},
computed:{
...mapState(["userInfo"])
},
async mounted(){
        this.$store.commit('initIsUpdateToken');
        const type=this.type;
        if(type==="1"){
            await this.getSchoolDeatil();
        }else if(type==="2"){
            await this.getZyzDeatil();
        }
        await this.getZszc();
        this.detail.jj=this.highlight(this.detail.jj);
        this.detail.lsjj=this.highlight(this.detail.jj);
        const maxwidth=this.maxwidth;
        let txt=this.detail.jj;
        if(txt.length>maxwidth){
            txt=txt.substring(0,maxwidth)+".......";
        }
        this.detail.jj=txt;
}
};
</script>
<style lang="less" scoped>
/deep/ .el-table .yuceTdx{
    color: #ED4A09 !important;
}
#zyData{
    // width: 790px;
    // margin: 0 auto;
}
.school-detail-wraper{
    min-width:1100px;
    margin:0 auto;
    min-height:calc(100vh - 380px);
    min-height:-moz-calc(100vh - 380px);
    min-height:-webkit-calc(100vh - 380px);
    .card-top{
        width: 1100px;
        margin: 20px auto;
    }
    .detail-top{
        display: flex;
        align-items: center;
        // width: 1100px;
        width: 1200px;
        margin: 0 auto;
        padding: 20px 0;
        background-color: #fff;
        .top-logo{
            width: 80px;
            height: 80px;
            box-sizing: border-box;
            margin: 0 30px;
        }
        .top-mid{
            // width: 80%;
            width: 84%;
            box-sizing: border-box;
            color: #666;
        }
        .mid-school-name{
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            font-size: 18px;
            color: #333;
        }
        .mid-school-nature{
            display: flex;
            font-size: 14px;
            .nature-item{
                flex: 1;
                .school-link{
                    cursor: pointer;
                }
            }
        }
    }
    .detail-main{
        box-sizing: border-box;
        // width: 1100px;
        width: 1200px;
        margin: 0 auto;
        padding: 20px 30px;
        background-color: #fff;
    }
}
.schoolIntro_con2 {
    // width: 790px;
    // width: 890px;
    width: 990px;
    padding-top: 0;
    overflow: hidden;
    // margin: 0 20px 50px 190px;
    min-height: 500px;
    margin-left:15px;
    // padding-top: 130px;
}
.catTitle2 {
    height: 35px;
    border-left: 5px solid #5287c6;
    padding-left: 20px;
    margin-bottom: 20px;
    margin-top: 20px;
    h2{
        font-size: 26px;
        line-height: 35px;
        font-weight: normal;
        color: #333;
    }
}
.info-data{
    width: 100%;
    color: #666;
    th{
        border: 1px solid #09f;
        padding: 1px 0;
        text-align: center;
        background-color: #e4f5ff;
    }
    td{
        padding: 1px 5px;
        border: 1px solid #09f;
        text-align: center;
    }
}
.schoolIntro_con {
    // margin: 30px 0 30px 180px;
    min-height: 500px;
    width: 510px;
    float: left;
    display: inline;
    .intro{
        text-align: justify;
        word-wrap: break-word;
        margin-bottom: 15px;
    }
    .txt{
        text-align: justify;
        word-wrap: break-word;
        margin-bottom: 35px;
    }
    a{
        color: #2186de;
    }
}
.baseInfo{
    border-top: 2px solid #efaf49;
    // background: url(school.css);
    line-height: 33px;
    margin-bottom: 20px;
    height: 170px;
    li{
        height: 33px;
        vertical-align: top;
    }
    .t{
        float: left;
      }
      .c{
        float: right;
        text-align: right;
        color: #999;
      }
}
.clearfix {
    *zoom: 1;
}
.baseInfo_left {
    float: left;
    width: 47%;
}
.baseInfo_right {
    float: right;
    width: 47%;
}
.catTitle {
    height: 35px;
    border-left: 5px solid #efaf49;
    padding-left: 20px;
    margin-bottom: 10px;
    h2{
        font-size: 26px;
        line-height: 35px;
        font-weight: normal;
        color: #efaf49;
        text-align: left;
    }
}
.schoolIntro_side {
    float: right;
    width: 260px;
    margin-top: 30px;
    .infos{
        border: 1px solid #E5E5E5;
        border-top: 0;
        ul{
            padding: 5px 12px 12px 12px;
        }
        li{
            padding: 10px 0 10px 75px;
            border-bottom: 1px dashed #DDD;
            line-height: 18px;
            word-wrap: break-word;
            overflow: hidden;
        }
        label{
            float: left;
            margin-left: -75px;
        }
        .website{
            height: 30px;
            margin-left: 15px;
            margin-bottom: 10px;
            a{
                line-height: 28px;
                float: left;
                border: 1px solid #D6D6D6;
                border-radius: 5px;
                text-align: center;
            }
            .a1{
                width: 90px;
                margin-right: 13px;
            }
            .a2{
                width: 120px;
            }
        }
    }
}
.schoolIntro_sideBd {
    width: 260px;
}
.schoolPic_slide {
    width: 260px;
    height: 240px;
    overflow: hidden;
    position: relative;
    ul{
        width: 260px;
        height: 240px;
        overflow: hidden;
    }
    li{
        float: left;
    }
    img{
        width: 260px;
        height: 240px;
    }
}
.collectBtn{
    width: 36px;
    padding: 3px;
    margin: 0 auto;
    font-size: 13px;
    color: #fff;
    border: 1px solid #f17070;
    border-radius: 3px;
    background: #f17070;
    cursor: pointer;
    box-sizing: content-box;
}
.schoolIntro_con22 {
    width: 790px;
    padding-top: 0;
    overflow: hidden;
    margin-left:15px;
    .majorCon2 {
    height: 35px;
    border-left: 5px solid #efaf49;
    padding-left: 20px;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #efaf49;
    clear: left;
}
h3{
    font-size: 26px;
    line-height: 35px;
    font-weight: normal;
    color: #efaf49;
}
.majorCon1 {
    margin-bottom: 25px;
    .list{
        margin-bottom: 15px;
    // background: url(school.css);
    li{
        // background: url(school.css) no-repeat 28px 20px;
        text-indent: 18px;
        height: 45px;
        line-height: 45px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        float: left;
        width: 235px;
        padding-left: 15px;
        list-style: square;
    }
    }
}
}
.schoolIntro_con23 {
    width: 790px;
    padding-top: 0;
    overflow: hidden;
    margin-left:15px;
    .majorCon2 {
    height: 35px;
    border-left: 5px solid #efaf49;
    padding-left: 20px;
    padding-bottom: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #efaf49;
    clear: left;
    h3{
        font-size: 26px;
    line-height: 35px;
    font-weight: normal;
    color: #efaf49;
    }
}
.txt{
    margin-bottom: 20px;
}
}
.yuceTdx{
    color: #ED4A09;
}
.yx_zy_group {
    box-sizing: border-box;
    border: 1px solid #eaeaea;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
}
.group_title {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    padding: 5px;
    font-size: 18px;
    font-weight: 600;
    color: #fefefe;
    background: rgb(38, 190, 228);
    .collect{
        padding: 3px 10px;
        font-size: 14px;
        color: #fff;
        border: 1px solid #f17070;
        border-radius: 3px;
        background: #f17070;
        cursor: pointer;
    }
}
.group_content {
    padding: 10px 0 10px;
    border-bottom: 1px solid #eaeaea;
    .zy_name {
    width: 96%;
    padding-left: 15px;
    font-size: 16px;
    color: #303133;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    .index{
        display: inline-block;
        padding: 0 6px;
        background-color: #5bc3ef33;
    }
    .tip{
        font-size: 14px;
        color: #606266;
    }
}
.zy_attrs {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    margin: 10px 0 0;
    .attr-item:first-child {
    margin-left: 40px;
    }
    .attr-item {
    margin-right: 20px;
    padding: 0 10px;
    border-radius: 3px;
    font-size: 12px;
    color: #ff6900;
    background-color: #ff690021;
}
}
}
.seMangSeRuo{
    // font-size: 14px;
    // color: #606266;
    color: red;
}
h1, h2, h3, h4, h5, h6{
    font-weight: normal !important;
    margin: 0 !important;
}
p{
    margin-bottom: 0;
}

a {
    cursor: pointer;
    color: #333;
    text-decoration: none;
    -moz-outline: 0
}
</style>
